import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";

export default function AdminLayout() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="d-flex" style={{ minHeight: "100vh" }}>
      <AdminSidebar collapsed={collapsed} />

      <div className="flex-grow-1 bg-light">
        <AdminHeader toggle={() => setCollapsed(!collapsed)} />

        <div className="p-4">
          <Outlet /> {/* ✅ THIS FIXES YOUR ISSUE */}
        </div>
      </div>
    </div>
  );
}